import { ChecklightSessionStatus } from '@thesavingsgroup/enums/ChecklightSessionStatus';

export const NEW_APPLICATION_STATUSES: string[] = [
  ChecklightSessionStatus.PENDING_SUBMISSION,
];
